export default [
  {
    name: "dashboard",
    children: [
      {
        name: "TourThrowDetail",
        path: "/manage/tour/throw/detail",
        component: (resolve) => require(["./tour/throw/detail.vue"], resolve),
      },
      {
        name: "TourThrowList",
        path: "/manage/tour/throw/list",
        component: (resolve) => require(["./tour/throw/list.vue"], resolve),
      },
      {
        name: "TourThrowEdit",
        path: "/manage/tour/throw/edit",
        component: (resolve) => require(["./tour/throw/edit.vue"], resolve),
      },
      {
        name: "TourProductDetail",
        path: "/manage/tour/product/detail",
        component: (resolve) => require(["./tour/product/detail.vue"], resolve),
      },
      {
        name: "TourRoomList",
        path: "/manage/tour/room/list",
        component: (resolve) => require(["./tour/room/list.vue"], resolve),
      },
      {
        name: "TourRoomDetail",
        path: "/manage/tour/room/detail",
        component: (resolve) => require(["./tour/room/detail.vue"], resolve),
      },
      {
        name: "HotelProductDetail",
        path: "/manage/hotel/product/detail",
        component: (resolve) => require(["./hotel/product/detail.vue"], resolve),
      },
      {
        name: "HotelThrowList",
        path: "/manage/hotel/throw/list",
        component: (resolve) => require(["./hotel/throw/list.vue"], resolve),
      },
      {
        name: "HotelThrowDetail",
        path: "/manage/hotel/throw/detail",
        component: (resolve) => require(["./hotel/throw/detail.vue"], resolve),
      },
      {
        name: "HotelPolicyList",
        path: "/manage/hotel/dispose/list",
        component: (resolve) => require(["./hotel/dispose/list.vue"], resolve),
      },
      {
        name: "HotelPolicyDetail",
        path: "/manage/hotel/dispose/detail",
        component: (resolve) => require(["./hotel/dispose/detail.vue"], resolve),
      },
      {
        // name: "HotelRoomList",
        path: "/manage/hotel/room/list",
        component: (resolve) => require(["./hotel/room/list.vue"], resolve),
      },
      {
        // name: "HotelRoomDetail",
        path: "/manage/hotel/room/detail",
        component: (resolve) => require(["./hotel/room/detail.vue"], resolve),
      },
      {
        // name: "HotelRoomDetail",
        path: "/manage/hotel/risk/detail",
        component: (resolve) => require(["./hotel/risk/detail.vue"], resolve),
      },
      {
        // name: "HotelRoomDetail",
        path: "/manage/hotel/risk/list",
        component: (resolve) => require(["./hotel/risk/list.vue"], resolve),
      },
      {
        // name: "HotelRoomDetail",
        path: "/manage/hotel/filter/detail",
        component: (resolve) => require(["./hotel/filter/update.vue"], resolve),
      },
      {
        // name: "HotelRoomDetail",
        path: "/manage/hotel/filter/list",
        component: (resolve) => require(["./hotel/filter/list.vue"], resolve),
      },

      {
        // name: "HotelRoomDetail",
        path: "/manage/flight/berth/list",
        component: (resolve) => require(["./flight/list.vue"], resolve),
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/views/manage/policy/router.js